import React, { ReactNode } from 'react';
import { Box, Grid } from '@mui/material';

import { InfoField, EmptyValue } from '@occc/ui-design-system';
import { MembershipFragment } from '@occc/graphql';
import { readableDate } from '@occc-app/lib/format';
import { formatPhoneNumberNationalForUS } from '@occc/utils-phone-number';

import MemberExternalIdFields from './MemberExternalIdFields';

type MemberDetailsFieldsProps = {
  member: MembershipFragment;
};

type MemberDetailsField = {
  name: string;
  attribute: keyof MembershipFragment;
  defaultValue: ReactNode;
  format?: (input: string) => string;
};

const fields: MemberDetailsField[] = [
  {
    name: 'Phone',
    attribute: 'phone',
    defaultValue: 'No Phone',
    format: (phone) => formatPhoneNumberNationalForUS(phone) ?? 'No Phone',
  },
  {
    name: 'Email',
    attribute: 'email',
    defaultValue: 'No Email',
  },
  {
    name: 'Birthdate',
    attribute: 'birthdate',
    defaultValue: 'No Birthdate',
    format: readableDate,
  },
  {
    name: 'Member Since',
    attribute: 'createdAt',

    // Should never occur (this field is required)
    defaultValue: <EmptyValue />,
    format: readableDate,
  },
];

const MemberDetailsFields = ({ member }: MemberDetailsFieldsProps) => {
  return (
    <Box>
      <Grid container spacing={3}>
        {fields.map((field) => {
          const value = member?.[field.attribute]?.toString();
          return (
            <Grid item xs={12} md={3} key={field.attribute}>
              <InfoField
                label={field.name}
                value={value && field.format ? field.format(value) : value || field.defaultValue}
                sx={{ overflowWrap: 'anywhere' }}
              />
            </Grid>
          );
        })}
        <MemberExternalIdFields externalLoyaltyIds={member.externalLoyaltyIds} />
      </Grid>
    </Box>
  );
};

export default MemberDetailsFields;
